interface ErrorStatusBadgeProps {
  status: number;
}

export const ErrorStatusBadge = ({ status }: ErrorStatusBadgeProps) => {
  return (
    <h1 className="text-6xl font-extrabold text-destructive mb-2">{status}</h1>
  );
};
